<template>
    <div class="consumption-list-container">
        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-input v-model="searchForm.service_name" placeholder="请输入服务名称" clearable size="large"
                style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
                <template #prefix>
                    <el-icon>
                        <Search />
                    </el-icon>
                </template>
            </el-input>

            <el-button type="primary" size="large" @click="handleSearch">
                <el-icon>
                    <Search />
                </el-icon>
                搜索
            </el-button>
        </div>

        <!-- 消费记录列表 -->
        <el-table :data="consumptionList" stripe style="width: 100%; margin-top: 20px" v-loading="loading"
            class="consumption-table">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column label="关联用户" width="120">
                <template #default="{ row }">
                    <div class="user-info">
                        <div class="user-nickname">{{ getUserInfo(row.user_id).nickname }}</div>
                        <div class="user-phone">{{ getUserInfo(row.user_id).phone }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="consumption_type" label="消费类型" width="120">
                <template #default="{ row }">
                    <el-tag :type="getConsumptionTypeTag(row.consumption_type)">
                        {{ getConsumptionTypeText(row.consumption_type) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="service_name" label="服务名称" width="200" />
            <el-table-column prop="points_before" label="消费前点数" width="120" align="right">
                <template #default="{ row }">
                    {{ formatPoints(row.points_before) }}
                </template>
            </el-table-column>
            <el-table-column prop="points_used" label="使用点数" width="120" align="right">
                <template #default="{ row }">
                    <span style="color: #ff7048">-{{ formatPoints(row.points_used) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="points_after" label="消费后点数" width="120" align="right">
                <template #default="{ row }">
                    {{ formatPoints(row.points_after) }}
                </template>
            </el-table-column>
            <el-table-column prop="ip_v6_address" label="IP地址" />
            <el-table-column prop="create_time_formatted" label="消费时间"  />

            <el-table-column label="操作" fixed="right">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="openDetailDialog(scope.row)">
                        详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination-container">
            <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
                @size-change="fetchConsumptionList" @current-change="fetchConsumptionList" />
        </div>

        <!-- 详情对话框 -->
        <el-dialog v-model="detailDialogVisible" title="消费记录详情" width="600px" class="detail-dialog">
            <div v-if="currentDetail" class="detail-content">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="记录ID">{{ currentDetail.id }}</el-descriptions-item>
                    <el-descriptions-item label="关联用户">
                        {{ getUserInfo(currentDetail.user_id).nickname }} ({{ getUserInfo(currentDetail.user_id).phone }})
                    </el-descriptions-item>
                    <el-descriptions-item label="消费类型">
                        <el-tag :type="getConsumptionTypeTag(currentDetail.consumption_type)">
                            {{ getConsumptionTypeText(currentDetail.consumption_type) }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="服务名称">{{ currentDetail.service_name }}</el-descriptions-item>
                    <el-descriptions-item label="消费前点数">{{ formatPoints(currentDetail.points_before) }}</el-descriptions-item>
                    <el-descriptions-item label="使用点数">
                        <span style="color: #ff7048">-{{ formatPoints(currentDetail.points_used) }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="消费后点数">{{ formatPoints(currentDetail.points_after) }}</el-descriptions-item>
                    <el-descriptions-item label="关联记录ID">
                        {{ currentDetail.related_id || '无' }}
                    </el-descriptions-item>
                    <el-descriptions-item label="IP地址">{{ currentDetail.ip_v6_address }}</el-descriptions-item>
                    <el-descriptions-item label="消费时间">{{ currentDetail.create_time_formatted }}</el-descriptions-item>
                </el-descriptions>
            </div>

            <template #footer>
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import Cookies from 'js-cookie'
import { Search } from '@element-plus/icons-vue'

export default {
    name: 'ConsumptionList',
    components: { Search },
    data() {
        return {
            loading: false,
            consumptionList: [],
            userList: [],
            userMap: {},
            searchForm: {
                service_name: ''
            },
            pagination: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            detailDialogVisible: false,
            currentDetail: null
        }
    },
    computed: {
        userInfo() {
            return JSON.parse(Cookies.get('user_info') || '{}')
        }
    },
    mounted() {
        this.fetchConsumptionList()
        this.fetchUserList()
    },
    methods: {
        // 获取用户列表
        async fetchUserList() {
            try {
                const response = await axios.post(
                    `${config.BASE_URL}/site/api/associated_user.php`,
                    {
                        action: 'get_users',
                        store_id: this.userInfo.id
                    }
                )

                if (response.data.data) {
                    this.userList = response.data.data
                    this.userMap = {}
                    response.data.data.forEach(user => {
                        this.userMap[user.id] = user
                    })
                }
            } catch (error) {
                console.error('获取用户列表错误:', error)
            }
        },

        // 根据user_id获取用户信息
        getUserInfo(userId) {
            const user = this.userMap[userId]
            if (user) {
                return {
                    nickname: user.nickname,
                    phone: user.phone,
                    avatar: user.avatar
                }
            }
            return {
                nickname: '管理员',
                phone: '',
                avatar: ''
            }
        },

        // 获取消费记录列表
        async fetchConsumptionList() {
            this.loading = true
            try {
                const params = {
                    action: this.searchForm.service_name ? 'consumption_search' : 'consumption_list',
                    store_id: this.userInfo.id,
                    page: this.pagination.page,
                    page_size: this.pagination.pageSize
                }

                if (this.searchForm.service_name) {
                    params.service_name = this.searchForm.service_name
                }

                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    params
                )

                if (data.data) {
                    this.consumptionList = data.data
                    this.pagination.total = data.pagination?.total || data.data.length
                }
            } catch (error) {
                this.$message.error('获取消费记录失败')
                console.error('获取消费记录错误:', error)
            } finally {
                this.loading = false
            }
        },

        // 处理搜索
        handleSearch() {
            this.pagination.page = 1
            this.fetchConsumptionList()
        },

        // 打开详情对话框
        async openDetailDialog(row) {
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    {
                        action: 'consumption_detail',
                        store_id: this.userInfo.id,
                        id: row.id
                    }
                )

                if (data.success) {
                    this.currentDetail = data.data
                    this.detailDialogVisible = true
                } else {
                    this.$message.error(data.error || '获取详情失败')
                }
            } catch (error) {
                this.$message.error('获取详情失败')
                console.error('获取消费详情错误:', error)
            }
        },

        // 获取消费类型标签
        getConsumptionTypeTag(type) {
            const typeMap = {
                distillation: 'primary',
                article_creation: 'success',
                other: 'info'
            }
            return typeMap[type] || 'info'
        },

        // 获取消费类型文本
        getConsumptionTypeText(type) {
            const textMap = {
                distillation: '关键词蒸馏',
                article_creation: '文章创作',
                other: '其他'
            }
            return textMap[type] || type
        },

        // 格式化点数
        formatPoints(points) {
            return parseFloat(points).toFixed(2)
        }
    }
}
</script>

<style scoped lang="scss">
.consumption-list-container {
    padding: 0px;
}

.search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding: 16px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
}

.consumption-table {
    border: 1px solid rgba(255, 112, 72, 0.3);
    border-radius: 8px;
    overflow: hidden;

    :deep(.el-table) {
        background: transparent;

        th {
            background: rgba(255, 112, 72, 0.1) !important;
            color: #e0e6ff !important;
            border-bottom: 1px solid rgba(255, 112, 72, 0.3) !important;
        }

        tr {
            background: rgba(255, 255, 255, 0.05);

            &:hover {
                background: rgba(255, 255, 255, 0.1) !important;
            }
        }

        td {
            color: #e0e6ff !important;
            border-bottom: 1px solid rgba(255, 112, 72, 0.1) !important;
        }
    }
}

.pagination-container {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
}

.detail-content {
    :deep(.el-descriptions) {
        .el-descriptions__label {
            
            background: rgba(255, 112, 72, 0.1) !important;
        }

        .el-descriptions__content {
           
            background: rgba(255, 255, 255, 0.05) !important;
        }
    }
}

.user-info {
    .user-nickname {
        font-weight: 500;
        margin-bottom: 4px;
    }

    .user-phone {
        color: #909399;
        font-size: 12px;
    }
}
</style>

<style>
.detail-dialog .el-dialog {
    background: rgba(13, 5, 26, 0.95) !important;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 112, 72, 0.3);
}

.detail-dialog .el-dialog__header {
    border-bottom: 1px solid rgba(255, 112, 72, 0.2);
}

.detail-dialog .el-dialog__title {
    color: #ffffff !important;
}

.detail-dialog .el-descriptions__table {
    width: 100%;
}
</style>